import { gql } from '@apollo/client'

export const SubscriptionFragment = gql`
  fragment SubscriptionFragment on Subscription {
    id
    createdDate
    updatedDate
    canceledAt
    currentPeriodStart
    currentPeriodEnd
    status
    provider
    amount
  }
`
